import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative h-[520px] md:h-[640px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20Korean%20webtoon%20style%20cityscape%20at%20sunset%20with%20warm%20golden%20and%20coral%20tones%2C%20silhouettes%20of%20characters%2C%20stylized%20artistic%20illustration%2C%20minimal%20composition%2C%20clean%20modern%20aesthetic%2C%20action%20and%20romance%20elements%20blended%2C%20vibrant%20atmosphere&width=1600&height=900&seq=hero-bg-pudding-comics&orientation=landscape"
          alt="布丁漫画 - 韩漫推荐与排行"
          title="布丁漫画韩漫推荐 - 免费全集下拉式阅读"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-4xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
            布丁漫画 · 韩漫推荐与排行
          </h1>
          <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            精选热门韩漫推荐，实时韩漫排行，提供免费全集韩漫资源<br className="hidden md:block" />
            支持下拉式在线观看，韩系画风剧情一次看个够
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              onClick={() => {
                const hotSection = document.getElementById('hot-recommend');
                if (hotSection) {
                  hotSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即探索热门韩漫
            </button>
            <button
              onClick={() => {
                const rankingSection = document.getElementById('ranking');
                if (rankingSection) {
                  rankingSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="px-8 py-3 rounded-full bg-white/15 text-white font-medium text-sm whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer backdrop-blur-sm"
            >
              查看韩漫排行
            </button>
          </div>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
            {categories.slice(0, 6).map((cat) => (
              <button
                key={cat.slug}
                onClick={() => {
                  navigate(`/category/${cat.slug}`);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-white/10 text-white text-xs font-medium hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
              >
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </div>
                {cat.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <button
          onClick={() => {
            const hotSection = document.getElementById('hot-recommend');
            if (hotSection) {
              hotSection.scrollIntoView({ behavior: 'smooth' });
            }
          }}
          className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors cursor-pointer animate-bounce"
        >
          <i className="ri-arrow-down-line"></i>
        </button>
      </div>
    </section>
  );
}